export enum AlertDialogType {
    Simple,
    Confirm,
    Delete,
    Archive,
    Unarchive,
    Leave,
}

export type AlertDialogOptions = {
    title: string;
    description: string;
    type: AlertDialogType;
};
